import {
  FeatureDto,
  FeatureLabelVM,
  FeaturePayloadVM,
} from "../types/feature.definition";
import {
  getAllFeatures,
  getFeatureById,
  createFeature,
  updateFeature,
  toggleFeature,
  deleteFeature,
} from "../webclients/feature.client";

export const featureApi = {
  getAll: async (lang = "fr"): Promise<FeatureDto[]> => {
    const response = await getAllFeatures(lang);
    return response.data;
  },

  getOne: async (id: number, lang: string): Promise<FeatureDto> => {
    const response = await getFeatureById(id, lang);
    return response.data;
  },

  getAllTranslations: async (id: number): Promise<FeatureLabelVM> => {
    const [enRes, frRes, arRes] = await Promise.all([
      getFeatureById(id, "en"),
      getFeatureById(id, "fr"),
      getFeatureById(id, "ar"),
    ]);
    return {
      en: (enRes.data as FeatureDto).label ?? "",
      fr: (frRes.data as FeatureDto).label ?? "",
      ar: (arRes.data as FeatureDto).label ?? "",
    };
  },

  create: async (data: FeaturePayloadVM): Promise<FeatureDto> => {
    const response = await createFeature(data);
    return response.data;
  },

  update: async (id: number, data: FeaturePayloadVM): Promise<FeatureDto> => {
    const response = await updateFeature(id, data);
    return response.data;
  },

  toggleEnabled: async (id: number): Promise<FeatureDto> => {
    const response = await toggleFeature(id);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await deleteFeature(id);
  },
};
